import { useMemo } from 'react';

import { Token } from 'types/token';

import * as actions from './actions';
import { AssetSimple, AssetsStore } from './types';

import bindActions from '../bindActions';
import { useAssetsState, useStoreDispatch } from '../index';
import { ActionAsyncResult, ActionSimpleResult } from '../types';

type AssetsActions = {
    getAssets: () => ActionAsyncResult;
    processNewAssets: (assets: Token[] | AssetSimple[]) => ActionAsyncResult;
    clearAssets: () => ActionSimpleResult;
};

export const useAssetsActions = (): AssetsActions => {
    const dispatch = useStoreDispatch();

    // List Actions
    const { getAssets, processNewAssets, clearAssets } = actions;

    const assetsActions = useMemo(
        () =>
            bindActions(
                {
                    getAssets,
                    processNewAssets,
                    clearAssets,
                },
                dispatch,
            ) as unknown as AssetsActions,
        [dispatch],
    );

    return assetsActions;
};

const useAssetsStore = (): AssetsStore & AssetsActions => {
    const assetsStore = useAssetsState();
    const assetsActions = useAssetsActions();
    return { ...assetsStore, ...assetsActions };
};

export default useAssetsStore;
